import { useTranslation } from "../../hooks/useTranslation";
import { useMemo } from "react";
import { TabbedInterface } from "../../components/layout/tabbed-interface/TabbedInterface";
import { OrdersTab } from "./components/OrdersTab";
import { tabColumnMapping } from "./utils/orderListColumns";
import { Tab as MuiTab } from "@mui/material";
import { useOrderCounts } from "./utils/useOrderCounts";
import { Warning } from "@mui/icons-material";
import { SyncrosaleLoader } from "../../components/layout/components/SyncrosaleLoader";

export const Orders = () => {
  const { translate } = useTranslation("pages.orders");
  const { counts, loading } = useOrderCounts();

  const tabs = useMemo(
    () =>
      tabColumnMapping.map((tabColumnInfo) => ({
        label: `tabs.${tabColumnInfo.path}`,
        path: tabColumnInfo.path,
        component: <OrdersTab tabInfo={tabColumnInfo} />,
      })),
    [],
  );

  if (loading) {
    return <SyncrosaleLoader />;
  }

  return (
    <TabbedInterface
      tabs={tabs}
      tabCounts={counts}
      defaultPath="active"
      translate={translate}
      editable={true}
      editableLocationKey={"pages.orders"}
      renderTab={(tab, count, index) => {
        const isDelayed = tab.path === "delayedPurchase" && !!count;
        if (!isDelayed) return null;

        return (
          <MuiTab
            key={tab.path}
            label={translate(tab.label) + ` (${count})`}
            value={index}
            sx={{
              textTransform: "none",
              color: "warning.main",
              fontWeight: "bold",
            }}
            icon={<Warning />}
            iconPosition="start"
          />
        );
      }}
    />
  );
};
